import { FunctionComponent } from 'react'
import { useT } from '@transifex/react'
import { reactular } from '@vendhq/reactular'
import { useTitle } from '@vend/react-utilities'

export const useTranslateTitle = () => {
  const t = useT()
  const title = t('Sell')

  useTitle(title)
}

export const TranslateTitle: FunctionComponent = () => {
  useTranslateTitle()
  return null
}

export const ReactTranslateTitle = reactular(TranslateTitle, [], 'reactWrapper')
